import { render, staticRenderFns } from "./EditNumberZone.vue?vue&type=template&id=74c913ae"
import script from "./EditNumberZone.vue?vue&type=script&lang=js"
export * from "./EditNumberZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports